import { ApplicationNames, SharedApplicationConstants } from '@ddt-web/domain';

// This class is currently used to aid our migration for removing security enrichment on the ACServer side
export class PortfolioRetrievalParamsConfig {
	public static readonly DEFAULT = {
		skipSecurityEnrichment: true, // this needs to be skipped on AC server side as the asset resolve is done on FE if needed
		securityDetailsRc: 'bfa:acserver:portfolio-editor-security-enrichment',
		usePasModels: true, // Keeping this at common place, since it will be used across all apps
		modelsRc: 'ac:model-details'
	};

	public static readonly SKIP_SECURITY_ENRICHMENT_APPS = [
		ApplicationNames.PORTFOLIO_ANALYSIS_CONSTRUCTION,
		...SharedApplicationConstants.PC_APPS
	];
}
